export { Avatar, AvatarContextProvider, renderAvatar, useAvatar, useAvatarContext } from './components/Avatar/index';
export type { AvatarContextValue, AvatarSlots, AvatarProps, AvatarState } from './components/Avatar/index';
